<template>
    <section class="section broadcast broadcast-light pb-0">
        <div class="container">
            <div class="row">
                <div class="col-12 fix-scroll">
                    <div class="broadcast__inner wow fadeInUp" data-wow-duration="600ms">
                        <div class="row align-items-center items-gap-two">
                            <div class="col-12 col-xl-8 col-xxl-7">
                                <div class="section__content broadcast__inner-content">
                                    <h2 class="h2">Commercial & broadcast rights</h2>
                                    <div class="paragraph">
                                        <p>
                                            Your text to speech synthesized audio files are
                                            securely stored in the cloud. You can also create
                                            drafts and convert the text to audio at a later time.
                                            Clear, consistent, and professional voices for
                                            marketing, explainer, product, and YouTube videos.
                                        </p>
                                    </div>
                                    <div class="section__content-cta">
                                        <router-link to="/contact-us" class="btn btn--secondary">
                                            request A Demo
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-xl-4 col-xxl-5">
                                <div class="broadcast__thumb text-xl-center">
                                    <img :src="require('@/assets/images/broadcast-thumb.png')" alt="Image">
                                </div>
                            </div>
                        </div>
                        <div class="anime">
                            <img :src="require('@/assets/images/anime-three.png')" alt="Image" class="anime-one">
                            <img :src="require('@/assets/images/anime-two.png')" alt="Image" class="anime-two">
                        </div>
                    </div>
                    <div class="broadcast__inner wow fadeInUp" data-wow-duration="600ms">
                        <div class="row align-items-center items-gap-two">
                            <div class="col-12 col-xl-4 col-xxl-5">
                                <div class="broadcast__thumb text-xl-center">
                                    <img :src="require('@/assets/images/broadcast-thumb-two.png')" alt="Image">
                                </div>
                            </div>
                            <div class="col-12 col-xl-8 col-xxl-7">
                                <div class="section__content broadcast__inner-content">
                                    <h2 class="h2">Team Access for Collaboration</h2>
                                    <div class="paragraph">
                                        <p>
                                            Your text to speech synthesized audio files are
                                            securely stored in the cloud. You can also create
                                            drafts and convert the text to audio at a later time.
                                            Clear, consistent, and professional voices for
                                            marketing, explainer, product, and YouTube videos.
                                        </p>
                                    </div>
                                    <div class="section__content-cta">
                                        <router-link to="/sign-up" class="btn btn--secondary">
                                            sign up now
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="anime">
                            <img :src="require('@/assets/images/anime-three.png')" alt="Image" class="anime-one">
                            <img :src="require('@/assets/images/anime-two.png')" alt="Image" class="anime-two">
                        </div>
                    </div>
                    <div class="broadcast__inner wow fadeInUp" data-wow-duration="600ms">
                        <div class="row align-items-center items-gap-two">
                            <div class="col-12 col-xl-8 col-xxl-7">
                                <div class="section__content broadcast__inner-content">
                                    <h2 class="h2">Insanely Powerfull. Easy to use</h2>
                                    <div class="paragraph">
                                        <p>
                                            Your text to speech synthesized audio files are
                                            securely stored in the cloud. You can also create
                                            drafts and convert the text to audio at a later time.
                                            Clear, consistent, and professional voices for
                                            marketing, explainer, product, and YouTube videos.
                                        </p>
                                    </div>
                                    <div class="section__content-cta">
                                        <router-link to="/contact-us" class="btn btn--secondary">
                                            request A Demo
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-xl-4 col-xxl-5">
                                <div class="broadcast__thumb text-xl-center">
                                    <img :src="require('@/assets/images/broadcast-thumb-three.png')" alt="Image">
                                </div>
                            </div>
                        </div>
                        <div class="anime">
                            <img :src="require('@/assets/images/anime-three.png')" alt="Image" class="anime-one">
                            <img :src="require('@/assets/images/anime-two.png')" alt="Image" class="anime-two">
                        </div>
                    </div>
                    <div class="broadcast__inner wow fadeInUp" data-wow-duration="600ms">
                        <div class="row align-items-center items-gap-two">
                            <div class="col-12 col-xl-4 col-xxl-5">
                                <div class="broadcast__thumb text-xl-center">
                                    <img :src="require('@/assets/images/broadcast-thumb-four.png')" alt="Image">
                                </div>
                            </div>
                            <div class="col-12 col-xl-8 col-xxl-7">
                                <div class="section__content broadcast__inner-content">
                                    <h2 class="h2">Life-like Voice clones. As Real</h2>
                                    <div class="paragraph">
                                        <p>
                                            Your text to speech synthesized audio files are
                                            securely stored in the cloud. You can also create
                                            drafts and convert the text to audio at a later time.
                                            Clear, consistent, and professional voices for
                                            marketing, explainer, product, and YouTube videos.
                                        </p>
                                    </div>
                                    <div class="section__content-cta">
                                        <router-link to="/sign-up" class="btn btn--secondary">
                                            sign up now
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="anime">
                            <img :src="require('@/assets/images/anime-three.png')" alt="Image" class="anime-one">
                            <img :src="require('@/assets/images/anime-two.png')" alt="Image" class="anime-two">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Broadcast",
    };
</script>

<style>
    .broadcast .broadcast__inner {
        background-image: url('~@/assets/images/broadcast-bg.png');
    }
</style>


// WEBPACK FOOTER //
// src/components/page_components/use-case/Broadcast.vue